



















































































































import Vue from "vue"
import { Component } from "vue-property-decorator"
import { ROUTES } from "@/constants"
import { User } from "@/generated/graphql"
import { CatOrganization } from "@/store/modules/test-sessions/test-sessions"
@Component
export default class SearchForm extends Vue {
  async mounted(): Promise<void> {
    if (this.isNielsenUser) {
      await this.loadCatOrganizations()
      // Set Nielsen Media as default if not already set
      if (!this.catOrganizationId && this.catOrganizations.length > 0) {
        const nielsenMedia = this.catOrganizations.find(org => org.name === "Nielsen Media")
        if (nielsenMedia) {
          this.$store.commit("testSessions/updateCatOrganization", nielsenMedia.id)
        }
      }
    }
    this.loadUsers({ userSearch: "" })
  }

  get isNielsenUser(): boolean {
    return this.$store.getters["currentUser/currentUser"]?.isNielsenUser || false
  }

  get currentDate(): string {
    return this.$store.getters["testSessions/currentDate"]
  }

  get filter() {
    return this.$store.getters["testSessions/filter"]
  }

  get fromDate(): string {
    return this.$store.getters["testSessions/fromDate"]
  }

  get page(): number {
    return this.$store.getters["testSessions/page"]
  }

  get itemsPerPage(): number {
    return this.$store.getters["testSessions/itemsPerPage"]
  }

  get searchTerm(): string {
    return this.$store.getters["testSessions/searchTerm"]
  }

  get toDate(): string {
    return this.$store.getters["testSessions/toDate"]
  }

  get userId(): number {
    return this.$store.getters["testSessions/userId"]
  }

  get users(): User[] {
    return this.$store.getters["testSessions/users"]
  }

  get catOrganizations(): CatOrganization[] {
    return this.$store.getters["testSessions/catOrganizations"]
  }

  get catOrganizationId(): string {
    return this.$store.getters["testSessions/catOrganizationId"]
  }

  get router(): void {
    return this.replaceRoute()
  }

  clearFilter(): void {
    this.$store.dispatch("testSessions/clearFilter")
  }

  clearUser(): void {
    this.$store.dispatch("testSessions/clearUser")
  }

  // clearCatOrganization(): void {
  //   this.$store.dispatch("testSessions/clearCatOrganization")
  //   // Reload users without organization filter
  //   this.loadUsers({ userSearch: "" })
  // }

  clearSearch(): void {
    this.$store.dispatch("testSessions/clearSearch")
  }

  loadUsers(users: { [key: string]: string }) {
    const payload: any = { 
      userSearch: users.userSearch,
      catOrganizationId: this.isNielsenUser && this.catOrganizationId ? this.catOrganizationId : null
    }
    this.$store.dispatch("testSessions/loadUsers", payload)
  }

  async loadCatOrganizations() {
    await this.$store.dispatch("testSessions/loadCatOrganizations")
  }

  updateFromDate(fromDate: string): void {
    this.$store.dispatch("testSessions/updateFromDate", fromDate)
  }

  updateSearchTerm(searchTerm: string): void {
    this.$store.dispatch("testSessions/updateSearchTerm", searchTerm)
  }

  updateToDate(toDate: string): void {
    this.$store.dispatch("testSessions/updateToDate", toDate)
  }

  updateUser(user: string) {
    this.$store.dispatch("testSessions/updateUser", user)
  }

  updateCatOrganization(organizationId: string) {
    this.$store.dispatch("testSessions/updateCatOrganization", organizationId)
    // Reload users with the new organization filter
    this.loadUsers({ userSearch: "" })
  }

  replaceRoute(): void {
    this.$router
      .replace({
        name: ROUTES.TEST_SESSIONS.name,
        query: {
          from: this.fromDate,
          to: this.toDate,
          user: this.userId?.toString(),
          catOrganization: this.catOrganizationId,
          search: this.searchTerm,
          page: this.page.toString(),
          rows: this.itemsPerPage?.toString(),
        },
      })
      .catch(() => ({}))
  }

  trackFeature(): void {
    this.$gtag.event("filter", {
      event_category: "test_sessions",
      event_label: "Test Sessions Filter Click",
    })
  }
}
